import { cn } from '@/lib/cn'

/**
 * The Sastrex mark drawn inline so it follows the theme tokens (BRAND_GUIDELINES §2).
 * `active` pulses the amber core twice — reserved for an upload in progress.
 * `muted` drops the amber (empty states: the core is earned by action).
 */
export function HexMark({ className, active, muted }: { className?: string; active?: boolean; muted?: boolean }) {
  return (
    <svg viewBox="0 0 100 100" className={cn('shrink-0', className)} aria-hidden focusable="false">
      <polygon
        points="50,4 89.84,27 89.84,73 50,96 10.16,73 10.16,27"
        fill="var(--brand-subtle)"
        stroke={muted ? 'var(--border-strong)' : 'var(--brand)'}
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M50 50V4M50 50L89.84 27M50 50L89.84 73M50 50V96M50 50L10.16 73M50 50L10.16 27"
        stroke={muted ? 'var(--border-strong)' : 'var(--brand)'}
        strokeOpacity={muted ? 1 : 0.5}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <circle
        key={active ? 'on' : 'off'}
        cx="50"
        cy="50"
        r="8"
        fill={muted ? 'var(--border-strong)' : 'var(--accent)'}
        className={active ? 'sx-core-active' : undefined}
      />
    </svg>
  )
}
